import { render, staticRenderFns } from "./formheader.vue?vue&type=template&id=1af8c2df&scoped=true"
import script from "./formheader.vue?vue&type=script&lang=js"
export * from "./formheader.vue?vue&type=script&lang=js"
import style0 from "./formheader.vue?vue&type=style&index=0&id=1af8c2df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af8c2df",
  null
  
)

export default component.exports